

















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import MobileHelperMixin from '@/components/helpers/mobile-helper-mixin';

@Component
export default class Timezone extends mixins(MobileHelperMixin) {
  @Prop() conditions: any;
  
  name: string = 'timezone';
  timezone: any = { name: 'UTC' };

  mounted() {
    this.timezone = this.$store.state.timezoneList.find((e: any) => e.zone === this.conditions.timezone.values) 
      || this.$store.state.timezoneList.find((e: any) => e.zone === 'UTC');
  }

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value.timezone) {
      this.$set(this.conditions, 'timezone', {
        values: []
      });
    }
  } 

  @Watch('timezone.zone')
  onTimezoneChanged(value: any, oldValue: any) {
    this.$set(this.conditions, 'timezone', { values: value });
  }
}
